module.exports = __webpack_public_path__ + "img/plant-vase.7bb51fdb.png";